const FEEFO_REVIEWS_ENDPOINT = 'https://api.feefo.com/api/10/reviews/product';
const FEEFO_MERCHANT_IDENTIFIER = 'sharp-consumer-electronics';

const REVIEWS_SECTION_SELECTOR = '#feefo-product-reviews';
const FEEFO_REVIEWS_ELEMENT_SELECTOR = 'feefo-product-reviews';
const REVIEWS_ANCHOR_SELECTOR = 'a[href="#feefo-product-reviews"]';

type FeefoReviewsResponse = {
  summary?: {
    meta?: {
      count?: number;
    };
  };
  reviews?: unknown[];
};

function setReviewsVisibility(isVisible: boolean): void {
  const reviewsSection = document.querySelector<HTMLElement>(
    REVIEWS_SECTION_SELECTOR,
  );
  if (reviewsSection) {
    if (isVisible) {
      reviewsSection.style.removeProperty('display');
    } else {
      reviewsSection.style.display = 'none';
    }
  }

  const reviewAnchors = document.querySelectorAll<HTMLAnchorElement>(
    REVIEWS_ANCHOR_SELECTOR,
  );

  reviewAnchors.forEach((anchor) => {
    if (isVisible) {
      anchor.style.removeProperty('display');
      return;
    }

    // Keep top nav state clean when the target section is hidden.
    anchor.classList.remove('is-active');
    anchor.style.display = 'none';
  });
}

function getFeefoReviewsUrl(parentProductSku: string): string {
  const params = new URLSearchParams({
    parent_product_sku: parentProductSku,
    origin: window.location.hostname,
    merchant_identifier: FEEFO_MERCHANT_IDENTIFIER,
    since_period: 'ALL',
    full_thread: 'include',
    unanswered_feedback: 'include',
    page_size: '5',
    sort: '-updated_date',
    feefo_parameters: 'include',
    media: 'include',
    demographics: 'include',
    translate_attributes: 'exclude',
    empty_reviews: 'false',
    importedReviews: 'true',
  });

  return `${FEEFO_REVIEWS_ENDPOINT}?${params.toString()}`;
}

async function toggleFeefoReviewsSection(): Promise<void> {
  // Hide by default and reveal only if Feefo confirms real reviews.
  setReviewsVisibility(false);

  const reviewsSection = document.querySelector<HTMLElement>(
    REVIEWS_SECTION_SELECTOR,
  );
  if (!reviewsSection) {
    return;
  }

  const feefoReviewsElement = reviewsSection.querySelector<HTMLElement>(
    FEEFO_REVIEWS_ELEMENT_SELECTOR,
  );
  const parentProductSku = feefoReviewsElement
    ?.getAttribute('parent-product-sku')
    ?.trim();

  if (!parentProductSku) {
    return;
  }

  try {
    const response = await fetch(getFeefoReviewsUrl(parentProductSku));
    if (!response.ok) {
      return;
    }

    const payload = (await response.json()) as FeefoReviewsResponse;
    const reviewCount = payload.summary?.meta?.count ?? 0;
    const hasReviews =
      reviewCount > 0 ||
      (Array.isArray(payload.reviews) && payload.reviews.length > 0);

    if (hasReviews) {
      setReviewsVisibility(true);
    }
  } catch {
    // Keep hidden on request failure to avoid showing an empty reviews area.
  }
}

document.addEventListener('DOMContentLoaded', () => {
  void toggleFeefoReviewsSection();
});
